import React, { useState } from 'react';
import { Search, Building2, Shield, HeartPulse, Cpu, Database, Cloud, LineChart, Landmark, Zap, Factory, Truck, Wifi, Briefcase, Users } from 'lucide-react';
export function Industries() {
  const [searchTerm, setSearchTerm] = useState('');
  const industries = [{
    name: 'Aerospace & Defense',
    icon: <Zap className="w-5 h-5" data-id="element-214" />
  }, {
    name: 'Homeland Security',
    icon: <Shield className="w-5 h-5" data-id="element-215" />
  }, {
    name: 'Cybersecurity',
    icon: <Database className="w-5 h-5" data-id="element-216" />
  }, {
    name: 'Healthcare',
    icon: <HeartPulse className="w-5 h-5" data-id="element-217" />
  }, {
    name: 'Technology',
    icon: <Cpu className="w-5 h-5" data-id="element-218" />
  }, {
    name: 'Artificial Intelligence',
    icon: <Cpu className="w-5 h-5" data-id="element-219" />
  }, {
    name: 'Data Centers',
    icon: <Database className="w-5 h-5" data-id="element-220" />
  }, {
    name: 'Cloud Computing',
    icon: <Cloud className="w-5 h-5" data-id="element-221" />
  }, {
    name: 'Financial Services',
    icon: <LineChart className="w-5 h-5" data-id="element-222" />
  }, {
    name: 'Government Contracting',
    icon: <Landmark className="w-5 h-5" data-id="element-223" />
  }, {
    name: 'Energy & Utilities',
    icon: <Zap className="w-5 h-5" data-id="element-224" />
  }, {
    name: 'Manufacturing',
    icon: <Factory className="w-5 h-5" data-id="element-225" />
  }, {
    name: 'Transportation',
    icon: <Truck className="w-5 h-5" data-id="element-226" />
  }, {
    name: 'Telecommunications',
    icon: <Wifi className="w-5 h-5" data-id="element-227" />
  }, {
    name: 'Private Equity',
    icon: <Briefcase className="w-5 h-5" data-id="element-228" />
  }, {
    name: 'Nonprofit Organizations',
    icon: <Users className="w-5 h-5" data-id="element-229" />
  }];
  const filteredIndustries = industries.filter(ind => ind.name.toLowerCase().includes(searchTerm.toLowerCase()));
  return <section id="industries" className="py-24 bg-white" data-id="element-230">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-231">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6" data-id="element-232">
          <div className="max-w-2xl" data-id="element-233">
            <span className="text-gold font-semibold tracking-widest uppercase text-sm mb-4 block" data-id="element-234">
              Global Reach
            </span>
            <h2 className="text-3xl md:text-5xl font-serif-display font-bold text-navy-900 mb-4" data-id="element-235">
              Industries Served
            </h2>
            <p className="text-gray-600 text-lg" data-id="element-236">
              We understand the nuanced language, metrics, and strategic
              imperatives across diverse sectors.
            </p>
          </div>

          <div className="w-full md:w-72 relative" data-id="element-237">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-238">
              <Search className="h-4 w-4 text-gray-400" data-id="element-239" />
            </div>
            <input type="text" className="block w-full pl-10 pr-3 py-3 border border-gray-200 rounded-sm leading-5 bg-gray-50 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-gold focus:border-gold sm:text-sm transition-all" placeholder="Search industries..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-240" />
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4" data-id="element-241">
          {filteredIndustries.map((ind, index) => <div key={index} className="flex items-center space-x-3 p-4 border border-gray-100 rounded-sm hover:border-gold/50 hover:bg-navy-50/50 transition-colors group cursor-default" data-id="element-242">
              <div className="text-navy-400 group-hover:text-gold transition-colors" data-id="element-243">
                {ind.icon}
              </div>
              <span className="text-navy-900 font-medium text-sm" data-id="element-244">
                {ind.name}
              </span>
            </div>)}
        </div>

        {filteredIndustries.length === 0 && <div className="text-center py-8 text-gray-500" data-id="element-245">
            No industries found matching "{searchTerm}".
          </div>}
      </div>
    </section>;
}